import axiosGlobalInstance from './configHttpInstance/http-instance';
import mockEnterpriseDetail from './fakes/enterprise-detail';

const enterpriseDetail = (id) => {
  const useFake = !!Number(process.env.REACT_APP_MOCK_API);

  if(useFake) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(mockEnterpriseDetail), 500);
    });
  }

  const httpInstance = axiosGlobalInstance();

  return httpInstance({
    method: 'GET',
    url: `/enterprises/${id}`,
  });
}

export default enterpriseDetail;

